<template>
  <div
    class="content"
    id="msGiftCard"
  >
    <div class="title">
      <h3>{{$t('ms.siderText')[1].text}}</h3>
      <div class="title-underline"></div>
    </div>
    <!-- 标签页 -->
    <div class="card-group">
      <div
        class="card"
        v-for="item in list"
        :key="item.id"
      >
        <div class="card-title">
          <img
            :src="item.logoUrl"
            alt=""
          >
        </div>
        <hr>
        <div class="card-body">
          <div class="card-info">
            <div class="card-info-text">
              <span>ID: {{item.memberId}}</span>
              <span>Join date: {{item.createdOn | dateFormat}}</span>
            </div>
            <button
              class="card-info-btn"
              v-if="item.memberLevelDesc"
            >
              {{item.memberLevelDesc}}
            </button>
          </div>
          <button
            class="card-link"
            @click="goCard(item.memberId)"
          >
            <i class="iconfont icon-right"></i>
            View Card
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMemberCampaigns, getMemberUrl } from '@/api/coupon'
export default {
  data () {
    return {
      list: []
    }
  },
  methods: {
    callback (key) {
      console.log(key);
    },
    async getList () {
      const res = await getMemberCampaigns().catch(err => {
        if (err.response.status === 401) {
          // 说明权限不够
          this.$router.push('/')
        }
      })
      this.list = res.list
    },
    // 前往会员卡页面
    async goCard (memberId) {
      const winRef = window.open('', '_blank')
      const res = await getMemberUrl(memberId).catch(err => {
        winRef.close()
        if (err.response.status === 401) {
          console.log('err')
          // 说明权限不够
          this.$router.push('/')
        }
      })
      winRef.location = res.url
    }
  },
  created () {
    this.getList()
  },
  filters: {
    dateFormat (val) {
      return val.split(' ')[0]
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding-bottom: 150px;
  .title {
    margin-bottom: 30px;
    position: relative;
    text-align: left;
    .title-underline {
      content: '';
      position: relative;
      width: 32px;
      height: 5px;
      background-color: #ffbf00;
      border-radius: 3px;
      &::after {
        position: absolute;
        content: '';
        left: 37px;
        width: 5px;
        height: 5px;
        background-color: #ffbf00;
        border-radius: 50%;
      }
    }
  }
}

// 标签页
::v-deep .ant-tabs {
  .ant-tabs-bar {
    border-bottom: none;
  }
  .ant-tabs-nav-scroll {
    text-align: left;
  }
  .ant-tabs-nav .ant-tabs-tab {
    position: relative;
    margin: 12px 32px 12px 0;
    padding: 0 16px 0 16px;
    border-radius: 30px;
    &:nth-last-child(n + 2)::after {
      content: '';
      position: absolute;
      right: -16px;
      top: 0%;
      height: 100%;
      width: 1px;
      background-color: #cacaca;
    }
  }
  .ant-tabs-tab-active {
    border-bottom: none;
    background-color: #0f96bb;
    color: white;
  }
  .ant-tabs-ink-bar {
    background-color: transparent;
  }
}

.card-group {
  margin: 0 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &::after {
    content: '';
    width: 32%;
  }
  .card {
    flex: 0 1 32%;
    padding: 9px;
    margin: 15px 0;
    border-radius: 7px;
    border: none;
    filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.1));
    @media screen and (max-width: 1200px) {
      flex: 0 1 48%;
    }
    @media screen and (max-width: 768px) {
      flex: 0 1 100%;
    }
    .card-title {
      width: 100%;
      height: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 0;
      > img {
        display: block;
        max-height: 100%;
        max-width: 100%;
      }
    }
    .card-body {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 10px;
      .card-info {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 20px;
        width: 100%;
        font-family: Roboto;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
        .card-info-text {
          display: flex;
          flex-direction: column;
          > span:first-of-type {
            margin-bottom: 5px;
          }
        }
        .card-info-btn {
          padding: 3px 10px;
          font-family: Roboto;
          font-size: 14px;
          color: #ffffff;
          background: #c4c4c4;
          border-radius: 6px;
          border: none;
          outline: none;
        }
      }
      .card-link {
        font-family: Roboto;
        font-size: 16px;
        line-height: 19px;
        color: #0f96bb;
        outline: none;
        border: none;
        background-color: transparent;
        &:hover {
          color: rgb(18, 67, 100);
        }
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>